import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mobile-sidebar" }
const _hoisted_2 = {
  key: 0,
  class: "icon icon-s-search-blue icon--selected"
}
const _hoisted_3 = {
  key: 1,
  class: "icon icon-s-search icon--no-selected"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-s-profile" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "icon icon-s-template-blue icon--selected"
}
const _hoisted_6 = {
  key: 1,
  class: "icon icon-s-template icon--no-selected"
}
const _hoisted_7 = {
  key: 0,
  class: "icon icon-star-blue icon--selected"
}
const _hoisted_8 = {
  key: 1,
  class: "icon icon-s-star icon--no-selected"
}
const _hoisted_9 = {
  key: 0,
  class: "icon icon-s-profile-blue icon--selected"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-s-profile icon--no-selected" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RouterLink, {
      to: { path: '/procedures', query: { page: '1' }},
      class: _normalizeClass({'is-selected': _ctx.currentRoute === '/procedures'})
    }, {
      default: _withCtx(() => [
        (_ctx.currentRoute === '/procedures')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2))
          : (_openBlock(), _createElementBlock("span", _hoisted_3)),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('mobile.search')), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    (!_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAuthModal && _ctx.toggleAuthModal(...args))),
          class: "js-popup-link",
          style: {"cursor":"pointer"}
        }, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('auth_modal.btn')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 1,
          to: { path: '/templates', query: { page: '1' } },
          class: _normalizeClass({'is-selected': _ctx.currentRoute === '/templates'})
        }, {
          default: _withCtx(() => [
            (_ctx.currentRoute === '/templates')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5))
              : (_openBlock(), _createElementBlock("span", _hoisted_6)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('header.templates')), 1)
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 2,
          to: { path: '/favourites', query: { page: '1' }},
          class: _normalizeClass({'is-selected': _ctx.currentRoute === '/favourites'})
        }, {
          default: _withCtx(() => [
            (_ctx.currentRoute === '/favourites')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7))
              : (_openBlock(), _createElementBlock("span", _hoisted_8)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('header.favourites')), 1)
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 3,
          to: "/profile",
          class: _normalizeClass({'is-selected': _ctx.currentRoute === '/profile'})
        }, {
          default: _withCtx(() => [
            (_ctx.currentRoute === '/profile')
              ? (_openBlock(), _createElementBlock("span", _hoisted_9))
              : _createCommentVNode("", true),
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('profile_page.profile')), 1)
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true)
  ]))
}